export const primary = '#4e00c9'
